import { makeAuthenticatedRequest } from "helpers/authenticatedRequest";
import { GetSupersetDashboardEndPoint } from "common/constants";

export const getDashboards = async (signal = null) => {
    try {
        const url = `${GetSupersetDashboardEndPoint}`;
        const response = await makeAuthenticatedRequest(url, { method: "GET", signal });
        return response;
    } catch (err) {
        console.error("API ERROR:", err);
        throw err;
    }
};